/**
 * Pure decision logic for the segmented shading-preset control (issue #106):
 * Stylised | Natural. Simpler than qualityControl.ts's Auto/Low/Med/High
 * control — there is no auto-detection axis and no antialias-style reload
 * boundary (a preset switch always applies live) — but kept as its own
 * module for the same reason: DOM/renderer-free so the choice order and
 * labels are unit-tested in Node (main.ts owns the DOM wiring).
 */
import type { ShadingPreset } from '../core/shadingPreset';

/** Control order, left → right, matching the issue's UI example ("Stylised | Natural"). */
export const SHADING_CHOICES: readonly ShadingPreset[] = ['stylised', 'natural'];

/** Short button label for a preset. */
export function shadingLabel(preset: ShadingPreset): string {
  return preset === 'natural' ? 'Natural' : 'Stylised';
}
